import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Droplets, Wind, Shield, CheckCircle2, Clock, Leaf, Brush, SprayCan, Plane, Armchair, Cigarette, UtensilsCrossed, Droplet, Biohazard, Eraser, FileText } from 'lucide-react';
export function CleaningServices() {
  const addOns = [{
    icon: Brush,
    text: 'Carpet Extraction'
  }, {
    icon: SprayCan,
    text: 'Lavatory Deep Sanitation'
  }, {
    icon: Plane,
    text: 'Cockpit Detail'
  }, {
    icon: Armchair,
    text: 'Leather Conditioning'
  }, {
    icon: Cigarette,
    text: 'Cigarette and Odor Removal'
  }, {
    icon: UtensilsCrossed,
    text: 'Galley Deep Clean'
  }, {
    icon: Droplet,
    text: 'Seat Shampoo'
  }, {
    icon: Biohazard,
    text: 'Mold and Biohazard Cleaning'
  }, {
    icon: Eraser,
    text: 'Seat Stain Removal'
  }, {
    icon: FileText,
    text: 'Custom Quote'
  }];
  return <section id="cleaning" className="py-24 bg-navy relative border-b border-white/5" data-id="element-15" data-mp="2vvlkqnljkxkw">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16" data-mp="2rv1t1zjqmm65">
        <div className="text-center mb-12" data-id="element-17" data-mp="35vmaosdx2by2">
          <span className="text-gold font-bold uppercase mb-3 block" style={{
          fontSize: '18px',
          letterSpacing: '4px'
        }} data-id="element-18" data-mp="35t9twijwa7ml">
            Aircraft Cleaning
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-bold text-white mb-4 uppercase" data-id="element-19" data-mp="28840re8ir3sh">
            Let Us Make Your Aircraft Look Its Best.
          </h2>
          <p className="text-lg text-slate-400 max-w-2xl mx-auto" data-id="element-20" data-mp="2mybb16odhgi3">
            Professional aircraft cleaning, cabin restoration and exterior
            detailing services. Airline and MRO approved.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-16" data-id="element-21" data-mp="1phmbxkqt4sce">
          {[{
          text: 'Airline & MRO Approved',
          icon: Shield
        }, {
          text: 'Overnight AOG Service',
          icon: Clock
        }, {
          text: 'Attention to Detail',
          icon: Sparkles
        }, {
          text: 'Eco-Friendly Products',
          icon: Leaf
        }].map((badge, idx) => <div key={idx} className="flex items-center text-slate-300 bg-navy-light px-5 py-2 rounded-full border border-white/5" data-id="element-22" data-mp="36lt2d93yrq4x" data-mpi={idx}>
              <badge.icon className="w-4 h-4 text-gold mr-2" data-id="element-23" data-mp="3fko7ehv9uu6n" />
              <span className="text-sm font-medium uppercase tracking-wider" data-id="element-24" data-mp="3fniuyi9l0v4a">
                {badge.text}
              </span>
            </div>)}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16" data-id="element-25" data-mp="uufc6skkgs21">
          {/* Interior */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-light rounded-2xl p-8 border border-white/5" data-id="element-26" data-mp="zsgx7j1jz1g5">
            <div className="flex items-center mb-6" data-id="element-27" data-mp="w6tsrqzpqyx5">
              <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center mr-4 border border-gold/20" data-id="element-28" data-mp="w627b8ztyhkl">
                <Sparkles className="w-5 h-5 text-gold" data-id="element-29" data-mp="r54iidkbepa4" />
              </div>
              <h3 className="text-2xl font-heading font-bold text-white uppercase" data-id="element-30" data-mp="m72xvo78qhwj">
                Interior Cleaning Services
              </h3>
            </div>

            <div className="space-y-6" data-id="element-31" data-mp="d8hlybw9y14q">
              <div data-id="element-32" data-mp="d9iykksxuvok">
                <h4 className="text-gold font-medium mb-3 uppercase text-sm tracking-wider" data-id="element-33" data-mp="2bnc57g625ksy">
                  Private Aircraft Interior Cleaning
                </h4>
                <div className="bg-navy rounded-xl p-5 border border-white/5 space-y-4" data-id="element-34" data-mp="27m8tn5v1maxj">
                  <div data-id="element-35" data-mp="2epgmtjnnjgx8">
                    <span className="text-white font-medium block mb-2" data-id="element-36" data-mp="2emudpfl44tcw">
                      Light Cabin Cleaning
                    </span>
                    <p className="text-slate-400 text-sm" data-id="element-37" data-mp="25p0logudslvj">
                      Vacuuming, Wipe-down, Trash removal, Windows, Lavatories
                    </p>
                  </div>
                  <div className="border-t border-white/10 pt-4" data-id="element-38" data-mp="1vypgys2vi8nl">
                    <span className="text-white font-medium block mb-2" data-id="element-39" data-mp="1vwcrltuscw0i">
                      Deep Detail
                    </span>
                    <p className="text-slate-400 text-sm" data-id="element-40" data-mp="1m0jdi61f4ugm">
                      Leather conditioning, Carpet shampoo, Deep sanitation, Bin
                      cleaning, Galley and lav detail, Galley UV disinfecting,
                      Stain removal
                    </p>
                  </div>
                </div>
              </div>

              <div data-id="element-41" data-mp="1hy4yjx0veeum">
                <h4 className="text-gold font-medium mb-3 uppercase text-sm tracking-wider" data-id="element-42" data-mp="1i0r2znsgse8m">
                  A320 Family Interior Services
                </h4>
                <ul className="space-y-2" data-id="element-43" data-mp="tetdt5adr8lo">
                  {['Transit/Turn Cleaning', 'Overnight Interior Cleaning', 'Deep Interior Restoration'].map((item, i) => <li key={i} className="flex items-center text-slate-300 text-sm" data-id="element-44" data-mp="1hbqsn5zbbud3" data-mpi={i}>
                      <CheckCircle2 className="w-4 h-4 text-gold mr-3" data-id="element-45" data-mp="1cbump1721suw" /> {item}
                    </li>)}
                </ul>
              </div>

              <div className="bg-gold/10 border border-gold/30 rounded-xl p-4 flex items-start" data-id="element-46" data-mp="1m2p7s28kemer">
                <Clock className="w-5 h-5 text-gold mr-3 shrink-0 mt-0.5" data-id="element-47" data-mp="201yp558ibmkb" />
                <div data-id="element-48" data-mp="1zzvpdthjyf2e">
                  <span className="text-white font-bold block text-sm uppercase mb-1" data-id="element-49" data-mp="1v3f0gx2j3wo9">
                    Emergency AOG Service
                  </span>
                  <p className="text-gold-light text-sm" data-id="element-50" data-mp="srk8ecn9onje">
                    Short notice, overnight or return-to-service cleaning
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Exterior */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-navy-light rounded-2xl p-8 border border-white/5 flex flex-col" data-id="element-51" data-mp="16hdvapf7oxqh">
            <div className="flex items-center mb-6" data-id="element-52" data-mp="1pfghkwgdkgkl">
              <div className="w-10 h-10 rounded-full bg-navy flex items-center justify-center mr-4 border border-gold/20" data-id="element-53" data-mp="3n69mma6dx6qt">
                <Wind className="w-5 h-5 text-gold" data-id="element-54" data-mp="3r8ecqyxmjl8p" />
              </div>
              <h3 className="text-2xl font-heading font-bold text-white uppercase" data-id="element-55" data-mp="3jodjgs4vvd97">
                Exterior Dry Wash Services
              </h3>
            </div>

            <div className="space-y-6 flex-grow" data-id="element-56" data-mp="3ev0xkprl9kk5">
              <div data-id="element-57" data-mp="39x97m1ai88il">
                <h4 className="text-gold font-medium mb-3 uppercase text-sm tracking-wider" data-id="element-58" data-mp="39ytx3chyp19l">
                  Private Aircraft Dry Wash
                </h4>
                <div className="grid grid-cols-3 gap-3" data-id="element-59" data-mp="6h24bvw04dac">
                  {['Light Jet', 'Mid-Size Jet', 'Heavy Jet'].map((item, i) => <div key={i} className="bg-navy rounded-lg p-3 text-center border border-white/5" data-id="element-60" data-mp="1iqrdcaetmnw" data-mpi={i}>
                      <span className="text-slate-300 text-sm" data-id="element-61" data-mp="3onq559k0qea7">{item}</span>
                    </div>)}
                </div>
              </div>

              <div data-id="element-62" data-mp="2i4i6bcdyrtmh">
                <h4 className="text-gold font-medium mb-3 uppercase text-sm tracking-wider" data-id="element-63" data-mp="2d81fubjal368">
                  A320/A321 Exterior Dry Wash
                </h4>
                <div className="bg-navy rounded-xl p-5 border border-white/5" data-id="element-64" data-mp="h3bxdg92tm33">
                  <p className="text-slate-400 text-sm mb-4" data-id="element-65" data-mp="l704jxtsqfnt">
                    Complete exterior dry wash utilizing aviation-approved,
                    eco-friendly compounds that clean and protect the paint
                    surface without water runoff.
                  </p>
                  <ul className="space-y-2" data-id="element-66" data-mp="zw63dkoq23v6">
                    {['Fuselage cleaning', 'Wing and tail surfaces', 'Landing gear wipe-down', 'Window polishing'].map((item, i) => <li key={i} className="flex items-center text-slate-300 text-sm" data-id="element-67" data-mp="v3mrqt9lhit0" data-mpi={i}>
                        <CheckCircle2 className="w-4 h-4 text-gold mr-3" data-id="element-68" data-mp="1is5zn7oqftkk" />{' '}
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Add-ons */}
        <div data-id="element-69" data-mp="33a6x3ow7tymd">
          <h4 className="text-center text-white font-heading font-bold text-2xl uppercase mb-8" data-id="element-70" data-mp="3h36czrzwtuug">
            Popular Add-On Services
          </h4>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4" data-id="element-71" data-mp="3d2crt6duqu59">
            {addOns.map((item, idx) => {
            const Icon = item.icon;
            return <div key={idx} className="bg-navy-light border border-white/5 rounded-xl p-4 text-center hover:border-gold/30 transition-colors group" data-id="element-72" data-mp="2kegwa500r8a2" data-mpi={idx}>
                  <Icon className="w-5 h-5 text-gold mx-auto mb-2 opacity-70 group-hover:opacity-100 transition-opacity" data-id="element-73" data-mp="2td287hazjp1v" />
                  <span className="text-slate-300 text-xs uppercase tracking-wide font-medium" data-id="element-74" data-mp="dosk9cz553zh">
                    {item.text}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}